import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { MoreThan200Section } from './components/MoreThan200Section';
import { SnackWarningSection } from './components/SnackWarningSection';
import { PainPointsSection } from './components/PainPointsSection';
import { BenefitsRowSection } from './components/BenefitsRowSection';
import { ProductRevealSection } from './components/ProductRevealSection';
import { BonusGridSection } from './components/BonusGridSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
export function App() {
  useEffect(() => {
    const PIXEL_ID = '2214030559133868';
    const w = window as any;
    if (w.fbq) return;
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      document.head.appendChild(t);
    }
    w.fbq('init', PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-[#c4f000] selection:text-[#1f2e10]" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=2214030559133868&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <MoreThan200Section data-id="element-4" />
      <SnackWarningSection data-id="element-5" />
      <PainPointsSection data-id="element-6" />
      <BenefitsRowSection data-id="element-7" />
      <ProductRevealSection data-id="element-8" />
      <BonusGridSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <PricingSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <FinalCTASection data-id="element-14" />
    </div>;
}